let timelineData = [
  {
    id: 202511,
    name: "Astroism",
    title: "Game Developer",
    location: "Atlanta, GA",
    brief:
      "A 3D Unity adventure game featuring an astronaut cat exploring an alien spacecraft.",
    description: [
      "Led a 5-member team in development and project integration for a 3D Unity game, coordinating progress and ensuring a polished final delivery.",
      "Built core gameplay systems including player movement, combat, interaction handling, and enemy AI to enhance overall gameplay experience.",
      "Authored 15+ production C# scripts and integrated prefabs, scenes, and environment assets, reducing integration issues by 40%.",
      "Performed extensive debugging and playtesting to resolve critical gameplay and performance issues, achieving a 95% bug-free final build.",
    ],
    date: "Aug 2025 - Dec 2025",
    icon: "school",
    link: "",
  },
  {
    id: 202509,
    name: "HackGT: BetterDoctor",
    title: "Frontend Developer",
    location: "Atlanta, GA",
    brief:
      "An AI-assisted healthcare platform built in 36 hours at HackGT12 to streamline patient intake and doctor workflows.",
    description: [
      "Delivered an AI-assisted healthcare platform that streamlined patient intake and doctor workflows by 20%.",
      "Designed a React/Tailwind interface that improved user task completion speeds by 30% in testing.",
      "Implemented Firebase Authentication and Firestore to enable secure, real-time data flow for both patients and doctors.",
    ],
    date: "Sep 2025",
    icon: "school",
    link: "https://github.com/ShaHos348/GTHack",
  },
  {
    id: 202308,
    name: "Food & Fuel Company Internship",
    title: "Full-Stack Software Engineer",
    location: "Cumming, Georgia",
    brief:
      "A full-stack store management system with inventory, payroll, and employee login features.",
    description: [
      "Developed a store management system with AngularJS + NodeJS that automated payroll and inventory workflows to save staff 20+ hrs/week.",
      "Increased client feedback efficiency by 35% through applied Agile practices.",
      "Improved authentication reliability by integrating persistent MySQL and ExpressJS session management.",
    ],
    date: "May 2023 - Aug 2023",
    icon: "work",
    link: "https://github.com/ShaHos348/JuniorM",
  },
  {
    id: 202311,
    name: "GT WebDev Project Platform",
    title: "Backend Developer",
    location: "Atlanta, Georgia",
    brief:
      "A project showcase platform for GT WebDev with secure login and dynamic filtering features.",
    description: [
      "Collaborated with a team of 10 to build a platform showcasing club projects with dynamic filtering and galleries",
      "Implemented secure user authentication using JWT and MongoDB, ensuring encrypted, session-free login.",
      "Designed backend endpoints and project schema that supported live search, tag-based filtering, and scalable content uploads.",
    ],
    date: "Sep 2023 - Dec 2023",
    icon: "school",
    link: "https://github.com/ShaHos348/gt-webdev-project-platform",
  },
  {
    id: 202312,
    name: "Cosmic Crawlers",
    title: "Game Developer",
    location: "Atlanta, Georgia",
    brief:
      "A mobile dungeon crawler game with AI enemies, space-cat theme, and pattern-based architecture.",
    description: [
      "Led a 5-member team to develop a dungeon crawler Android game with enemy AI and combat mechanics.",
      "Implemented scalable and maintainable architecture such as Factory, Strategy, among others.",
      "Ensured stability with a 100%+ JUnit test pass rate.",
    ],
    date: "Aug 2023 - Dec 2023",
    icon: "school",
    link: "https://github.com/ShaHos348/Cosmic-Crawlers",
  },
  {
    id: 202505,
    name: "Georgia Tech VIP",
    title: "Backend Software Engineer",
    location: "Atlanta, Georgia",
    brief:
      "A course planning tool for GT students with automated scraping, graphing, and CSV generation.",
    description: [
      "Built a course-mapping React web app that improved academic path planning time for 1,000+ Georgia Tech students.",
      "Scripted scraping of 500+ courses using Python (BeautifulSoup, Selenium), reducing manual data entry time by 90%.",
      "Automated extraction of 200 undergraduate major and concentration combinations for course requirements.",
      "Produced linked course visualizations and CSV exports using Pandas and Matplotlib with 100% accuracy to improve user understanding.",
    ],
    date: "Jan 2024 - May 2025",
    icon: "work",
    link: "https://github.com/ShaHos348/IdealCourseMapping",
  },
  {
    id: 202512,
    name: "Georgia Tech OIT Internship",
    title: "Technical Support Agent Lead",
    location: "Atlanta, Georgia",
    brief:
      "An IT operations role managing assets, resolving support tickets, and training student workers.",
    description: [
      "Achieved 80% audit accuracy on 1,000+ IT assets across 6 campus departments, improving compliance and reducing discrepancies.",
      "Resolved 100+ technical incidents via ServiceNow, reducing average response times by ~20% while maintaining a 95% satisfaction rate.",
      "Trained and supervised 10+ student assistants, increasing onboarding efficiency and boosting team productivity by 30%.",
    ],
    date: "May 2024 - Dec 2025",
    icon: "work",
    link: "none",
  },
  {
    id: 202508,
    name: "MyExpense",
    title: "Full-Stack Developer",
    location: "Remote",
    brief:
      "An expense tracking web app with financial visualizations, mobile optimization, and JWT security.",
    description: [
      "Built an expense tracker web app managing 500+ financial records with 99% accuracy from manual input.",
      "Strengthened security with JWT-based authentication, reducing unauthorized request success to 0%.",
      "Created interactive D3.js visualizations covering 10+ categories, boosting user insights.",
      "Started development of a native Android version using Android Studio and Kotlin to expand user reach.",
    ],
    date: "May 2025 – Aug 2025",
    icon: "personal",
    link: "none",
  },
  {
    id: 202212,
    name: "Space Invaders",
    title: "Game Developer",
    location: "Athens, Georgia",
    brief:
      "A Java remake of the classic arcade game with custom UI and performance optimization.",
    description: [
      "Built a JavaFX version of the arcade classic Space Invaders with polished UI and gameplay.",
      "Refactored code for improved runtime efficiency and cleaner architecture.",
    ],
    date: "Nov 2022 - Dec 2022",
    icon: "school",
    link: "none",
  },
  {
    id: 202202,
    name: "Time Warp",
    title: "Game Developer",
    location: "Duluth, Georgia",
    brief:
      "A Unity-based 2D platformer exploring time-travel mechanics with A* enemy AI.",
    description: [
      "Designed a 2D Unity platformer featuring time-travel levels and A* enemy pathfinding.",
      "Handled both asset design and entity programming for a complete game experience.",
    ],
    date: "Nov 2021 - Feb 2022",
    icon: "school",
    link: "https://github.com/ShaHos348/Time-Warp",
  },
  {
    id: 202305,
    name: "UGA MarketPlace",
    title: "Frontend Developer",
    location: "Athens, Georgia",
    brief:
      "A web platform for UGA students to exchange goods, housing, and course spots securely.",
    description: [
      "Developed a student-only marketplace for UGA using React frontend and a Spring Boot backend with firebase authentication.",
      "Built features like textbook/item resale, dorm/apartment reviews, and sublease listings with secure UGA email sign-up.",
      "Implemented a course swap feature to allow students to trade class sections during registration periods.",
    ],
    date: "Jan 2023 - May 2023",
    icon: "school",
    link: "https://github.com/ShaHos348/openSourceSpring23",
  },
];

timelineData.sort((a, b) => b.id - a.id);

export default timelineData;
